import { styled } from '@mui/material/styles';
import { BORDER_RADIUS } from '@src/styles/config';

export const StyledLimitedInput = styled('div')`
  .input-field {
    ${({ customStyle }) => customStyle};
    .MuiOutlinedInput-root {
      border-radius: ${BORDER_RADIUS};
      /* Hide scrollbar but allow scroll */
      overflow: auto;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
    }
    .MuiOutlinedInput-root::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
    textarea {
      overflow: auto !important;
      resize: none;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      font-size: 14px;
    }
    textarea::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }
  /* this to remove background color for Textfield when autofill */
  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition: background-color 0s 600000s, color 0s 600000s !important;
  }
`;
